import {
    GET_PICKLIST_DOMAIN_DATA_REQUEST,
    GET_PICKLIST_DOMAIN_DATA_SUCCESS,
    GET_PICKLIST_DOMAIN_DATA_FAILURE
} from "./actions";

const initialState = {
    domainData: {
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_PICKLIST_DOMAIN_DATA_REQUEST:
            return {
                ...state,
                domainData: {
                    ...state.domainData,
                    [action.params.dataDomainId]: {
                        getDomainDataResult:{
                            inProgress: true,
                            success: true
                        },
                        domainDataResult: !action.params.pageKey ? { Items: [] } : state.domainData[action.params.dataDomainId].domainDataResult
                    }
                }
            };
        case GET_PICKLIST_DOMAIN_DATA_SUCCESS: {
            const { dataDomainId, domainDataResult, pageKey } = action.payload;
            const currentItems = state.domainData[dataDomainId]?.domainDataResult?.Items ?? [];
            const items = pageKey ? currentItems.concat(domainDataResult.Items) : domainDataResult.Items;

            return {
                ...state,
                domainData: {
                    ...state.domainData,
                    [dataDomainId]: {
                        getDomainDataResult:{
                            inProgress: false,
                            success: true
                        },
                        domainDataResult: {
                            ...domainDataResult,
                            Items: items.map((item, index) => ({ ...item, sNo: index + 1 }))
                        }
                    }
                }
            };
        }
        case GET_PICKLIST_DOMAIN_DATA_FAILURE:
            return {
                ...state,
                domainData: {
                    ...state.domainData,
                    [action.payload.dataDomainId]: {
                        getDomainDataResult:{
                            inProgress: false,
                            success: false,
                            ...action.payload.error
                        },
                        domainDataResult: state.domainData[action.payload.dataDomainId].domainDataResult
                    }
                }
            };
        default:
            return state;
    }
};
